import { render, staticRenderFns } from "./FormResult.vue?vue&type=template&id=1b54a610&scoped=true"
import script from "./FormResult.vue?vue&type=script&lang=js"
export * from "./FormResult.vue?vue&type=script&lang=js"
import style0 from "./FormResult.vue?vue&type=style&index=0&id=1b54a610&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54a610",
  null
  
)

export default component.exports